import { defineComponent as c, useCssVars as s, computed as a, createElementBlock as n, openBlock as r, normalizeClass as i, createVNode as l, unref as m } from "vue";
import { l as d, F as f } from "../../../../index.es-DHxYFDWC.js";
import p from "./icons.js";
import { _ as u } from "../../../../_plugin-vue_export-helper-CHgC5LLL.js";
import '../../../../assets/ds-atom-icon.css';const _ = /* @__PURE__ */ c({
  __name: "ds-atom-icon",
  props: {
    icon: {},
    type: { default: "solid" },
    size: { default: "auto" },
    color: { default: "" }
  },
  setup(e) {
    s((o) => ({
      "5ee5d5c0": o.color
    })), d.add(p);
    const t = a(() => e.type === "solid" ? "fas" : e.type === "regular" ? "far" : "fab");
    return (o, y) => (r(), n("div", {
      class: i(["icon", `icon--${o.size}`])
    }, [
      l(m(f), {
        icon: [t.value, o.icon]
      }, null, 8, ["icon"])
    ], 2));
  }
}), b = /* @__PURE__ */ u(_, [["__scopeId", "data-v-cce79642"]]);
export {
  b as default
};
